var r=(r,n)=>r[0]===n[0]&&r[1]===n[1]&&r[2]===n[2]&&r[3]===n[3];export default(n,t)=>{var u,a,e=t||r;return function(){return u&&e(arguments,u)?a:a=n.apply(null,u=arguments)}};
//# sourceMappingURL=index.mjs.map
